module.exports = __webpack_public_path__ + "img/charles-sumner.366deadd.png";